// @flow
import './PreLoginPageTemplate.styl';
import 'common/skins.styl';

import React from 'react';
import { connect } from 'react-redux';
import { Card, Image } from 'semantic-ui-react';

import Section from 'shared/components/Section';

import imgLoginLogo from 'shared/assets/logo.png';
import imgLoginText from './login_text.png';

import imgJustParkLogo from 'shared/assets/topnav-logo-Group 9076 JustPark.svg';

import ThemeUtils from "shared/utils/ThemeUtils";


type Props = {
  hasSessionEndedSuccessfully?: boolean,
  children: Node
};

const PreLoginPageTemplate = (props) => {
  const theClass = ThemeUtils.getCustomStyleClassForUserOrDomain(props.user, 'pre-login-page-template');
  return (
    <div className={theClass}>
      <Card className={`pre-login-page-card ${props.hasSessionEndedSuccessfully ? 'session-success' : ''}`}>
        {
          ThemeUtils.getCurrentTheme(props.user) === 'justpark' ? <JustParkSection/> : <SmarkingSection/>
        }{props.children}
      </Card>
    </div>
  );
};

PreLoginPageTemplate.defaultProps = {
  hasSessionEndedSuccessfully: false
};

const SmarkingSection = () => (
  <Section marginTop="0.5rem">
    <Image className="smk-logo-img" src={imgLoginLogo} centered/>
    <Image className="smk-logo-img" src={imgLoginText} centered/>
  </Section>

);

const JustParkSection = () => (
  <Section marginTop="0.5rem">
    <Image className="jp-logo-img" src={imgJustParkLogo} centered/>
  </Section>
);

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(PreLoginPageTemplate);
